import React, { useEffect, useState } from "react";
import { login } from "../services/authService";
import { MessageType } from "../contexts/MessageContext";
import { useShowMessage } from "../hooks/useShowMessage";

interface Props {
  onLoginSuccess: (token: string) => void;
}

const LoginForm = (props: Props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [slideIn, setSlideIn] = useState(false);
  const [slideOut, setSlideOut] = useState(false);
  const showMessage = useShowMessage();

  useEffect(() => {
    const timeout = setTimeout(() => setSlideIn(true), 50);
    return () => clearTimeout(timeout);
  }, []);

  const handleLogin = async () => {
    if (loading) return;
    setLoading(true);
    try {
      if (username == "" || password == "") {
        throw new Error("Login failed: Invalid credentials");
      }

      const token = await login(username, password);
      localStorage.setItem("token", token);

      // Trigger slide-out
      setSlideOut(true);
      setTimeout(() => {
        props.onLoginSuccess(token);
      }, 500); // faster than delay
    } catch (err) {
        await showMessage((err as Error).message, MessageType.Info);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`
        fixed left-1/2 "top-[50vh]" -translate-x-1/2 -translate-y-1/2 z-50
        w-full max-w-xs sm:max-w-sm bg-white p-6 rounded shadow-md border border-gray-200
        transition-top duration-700 ease-in-out
        ${slideOut ? "top-[-200px]" : slideIn ? "top-[50vh]" : "top-[calc(100vh+200px)]"}
      `}
    >
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="w-full mb-3 px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-sky-400"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full mb-4 px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-sky-400"
      />
      <button
        type="submit"
        disabled={loading}
        className="w-full bg-sky-600 text-white py-2 rounded hover:bg-sky-700 disabled:opacity-50"
      >
        {loading ? "Logging in..." : "Login"}
      </button>
    </form>
  );
};

export default LoginForm;
